import { render, staticRenderFns } from "./RekonsiliasiObatCard.vue?vue&type=template&id=509af9d8&"
import script from "./RekonsiliasiObatCard.vue?vue&type=script&lang=ts&"
export * from "./RekonsiliasiObatCard.vue?vue&type=script&lang=ts&"
import style0 from "./RekonsiliasiObatCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCombobox,VDataTable,VDivider,VIcon,VTextField})
